var scope_0 = require('/Users/wilmer/projects/wilmercantillo.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/358e8a190e3f2840090c8cbe1446440b.js').default;
var scope_1 = require('/Users/wilmer/projects/wilmercantillo.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/78e36428e25824dee9999d5112e6b766.js').default;
var scope_2 = require('/Users/wilmer/projects/wilmercantillo.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ee0257ce8c485afab6a25aacb5e71c62.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    